import { render } from "./MalukuIntroduction.vue?vue&type=template&id=43b14774&scoped=true"
const script = {}

import "./MalukuIntroduction.vue?vue&type=style&index=0&id=43b14774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b14774"]])

export default __exports__